export const SPEEDY_LOGO = "https://www.speedy.bg/public/assets/images/logo.svg";
